import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { OrderService } from '../../services/order.service';
import { Subscription } from 'rxjs';
import { DialogButtonComponent } from "../buttons/dialog-button.component";

@Component({
  standalone: true,
  imports: [DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-2xl w-full">
      <div class="p-6 w-96 max-w-full">
        <h2 class="text-xl font-bold mb-4">{{ modalData?.title }}</h2>
        <p class="text-theme-text">{{ modalData?.message }}</p>
        <div class="mt-4 flex gap-2 justify-end">
          <app-dialog-button
            [text]="modalData?.abortText || 'Avbryt'"
            (onClick)="close(false)">
          </app-dialog-button>
          <app-dialog-button
            [text]="modalData?.confirmText || 'Lämna'"
            (onClick)="confirm()"
            variant="primary">
          </app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class LeaveSmartTableDialogComponent implements OnDestroy {
  modalData?: {
    title: string;
    message: string;
    confirmText?: string;
    abortText?: string;
  };

  private sub?: Subscription;

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: any,
    private orderService: OrderService
  ) {
    this.modalData = data;
  }

  close(value: any = false): void {
    this.modalService.close(value);
  }

  confirm(): void {
    this.sub = this.orderService.leaveSmartTable().subscribe({
      next: res => {
        console.log('SmartTable lämnat:', res);
        this.close(true);
      },
      error: err => {
        console.error('Fel vid lämnande av SmartTable:', err);
        this.close(false);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
